import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'
import { useEffect } from 'react'
import Layout from '@components/Layout'
import Login from '@pages/Login'
import Dashboard from '@pages/Dashboard'
import AnalyticsPage from '@pages/Analytics'
import RoutesPage from '@pages/Routes'
import DriversPage from '@pages/Drivers'
import ApplicationsPage from '@pages/Applications'
import JobsPage from '@pages/Jobs'
import PassengersPage from '@pages/Passengers'
import BookingsPage from '@pages/Bookings'
import TicketsPage from '@pages/Tickets'
import VehiclesPage from '@pages/Vehicles'
import TripsPage from '@pages/Trips'
import TimetablesPage from '@pages/Timetables'
import OperatorsPage from '@pages/Operators'
import ControlCenterPage from '@pages/ControlCenter'
import InboxPage from '@pages/Inbox'
import ReconciliationPage from '@pages/Reconciliation'
import PartnerRequestsPage from '@pages/PartnerRequests'
import PayoutsPage from '@pages/Payouts'
import CommissionPage from '@pages/Commission'
import NotificationsPage from '@pages/Notifications'
import SettingsPage from '@pages/Settings'
import PricingPage from '@pages/Pricing'
import InsightsPage from '@pages/Insights'
import LatraTestPage from '@pages/LatraTest'
import LatraActivityPage from '@pages/LatraActivity'
import DeleteAccountPage from '@pages/DeleteAccount'
import DeleteDataPage from '@pages/DeleteData'
import LoadingSpinner from '@components/LoadingSpinner'
import PartnerPortalNotice from '@components/PartnerPortalNotice'

function App() {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  // Bus companies have their own portal on the public website; this app is for Daladala Smart staff.
  if (isAuthenticated && useAuthStore.getState().user?.role === 'operator') {
    return <PartnerPortalNotice />
  }

  return (
    <Routes>
      {/* Public routes - no authentication required */}
      <Route path="/delete-account" element={<DeleteAccountPage />} />
      <Route path="/delete-data" element={<DeleteDataPage />} />
      
      {/* Protected routes - require authentication */}
      {!isAuthenticated ? (
        <Route path="*" element={<Login />} />
      ) : (
        <Route path="*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to={useAuthStore.getState().user?.role === 'admin' ? '/control' : '/dashboard'} replace />} />
              <Route path="/control" element={<ControlCenterPage />} />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/reconciliation" element={<ReconciliationPage />} />
              <Route path="/partner-requests" element={<PartnerRequestsPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/routes" element={<RoutesPage />} />
              <Route path="/drivers" element={<DriversPage />} />
              <Route path="/applications" element={<ApplicationsPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/passengers" element={<PassengersPage />} />
              <Route path="/bookings" element={<BookingsPage />} />
              <Route path="/tickets" element={<TicketsPage />} />
              <Route path="/vehicles" element={<VehiclesPage />} />
              <Route path="/trips" element={<TripsPage />} />
              <Route path="/timetables" element={<TimetablesPage />} />
              <Route path="/operators" element={<OperatorsPage />} />
              <Route path="/bus-owners" element={<Navigate to="/operators" replace />} />
              <Route path="/payouts" element={<PayoutsPage />} />
              <Route path="/commission" element={<CommissionPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/latra-test" element={<LatraTestPage />} />
              <Route path="/latra-activity" element={<LatraActivityPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Layout>
        } />
      )}
    </Routes>
  )
}

export default App
